// Display-only split of the shared `leads` collection.
// Individual = client_type != "institutional" (existing leads); Institutional = Clients module.
export const LEAD_SCOPES = {
  individual: {
    key: "individual",
    clientType: "individual",
    eyebrow: "Demand Pipeline",
    title: "Leads",
    adminSubtitle: "All buyer-investor leads across the firm.",
    ownSubtitle: "Leads assigned to you. Inbound submissions land here automatically.",
    addLabel: "Add Lead",
    addPath: "/leads/new",
    basePath: "/leads",
    noun: "lead",
    firstColHeader: "Lead & Company",
  },
  institutional: {
    key: "institutional",
    clientType: "institutional",
    eyebrow: "Demand Pipeline",
    title: "Clients",
    adminSubtitle: "Institutional clients across the firm — family offices, funds, corporates.",
    ownSubtitle: "Institutional clients assigned to you.",
    addLabel: "Add Client",
    addPath: "/clients/new",
    basePath: "/clients",
    noun: "client",
    firstColHeader: "Client & Company",
  },
};
